import { TSelectOpt } from 'transfix-ui/components/Select/SelectTypes'
import { MARKETPLACE_EQUIPMENT_TYPES } from 'constants/equipment'

export const RADIUS_OPTIONS: TSelectOpt[] = [
  { value: 1, label: '1 mi' },
  { value: 25, label: '25 mi' },
  { value: 50, label: '50 mi' },
  { value: 100, label: '100 mi' },
  { value: 150, label: '150 mi' },
  { value: 200, label: '200 mi' },
  { value: 250, label: '200+ mi' }, // What's the value for '200+' ?
]

export const EQUIPMENT_OPTIONS = MARKETPLACE_EQUIPMENT_TYPES.map(equipment => ({
  value: equipment.key,
  label: equipment.name,
}))

export const SORT_OPTIONS = [
  { value: 'pickups', label: 'Sort by Pickup Time' },
  { value: 'deliveries', label: 'Sort by Dropoff Time' },
]

export const LOAD_METHOD_OPTIONS = [{ value: 'dropTrailer', label: 'Only drop trailer' }]
